import classNames from "classnames";

import Paper, { PaperProps } from "../Paper/Paper";

import styles from "./CardPicasso.module.css";

const CardPicasso: React.FC<CardPicassoProps> = ({
  title,
  titleAs: TitleComponent = "p",
  image,
  actions,
  children,
  label,
  className,
  ...rest
}) => {
  return (
    <Paper className={classNames(styles.card, className)} {...rest}>
      {image && <div className={styles.image}>{image}</div>}
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.content}>
        <TitleComponent className={styles.title}>{title}</TitleComponent>
        {children && <div className={styles.children}>{children}</div>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </Paper>
  );
};

export type CardPicassoProps = {
  children?: React.ReactNode;
  title: string;
  titleAs?: keyof JSX.IntrinsicElements | React.FC;
  label?: React.ReactNode;
  className?: string;
  image?: React.ReactNode;
  actions?: React.ReactNode;
} & Omit<PaperProps, "label">;

export default CardPicasso;
